function submitForm(that) {
    $('.js-form-group').removeClass('has-error');
    that.find('button[type="submit"]').prop('disabled', 'disabled');
    var data = that.serializeArray().reduce(function(prev, current) {
      prev[current.name] = current.value
      return prev;
    }, {});
    if (data.phone_number != '') {
        data.phone_number = '+33' + data.phone_number;
    }
    // $.ajaxSetup({
    //     beforeSend: function(xhr, settings) {
    //         xhr.setRequestHeader("X-CSRFToken", window.csrftoken);
    //     }
    // });
    $.ajax({
        url: that.data('action'),
        data: JSON.stringify(data),
        processData: false,
        contentType: 'application/json',
        type: 'POST',
        success: function (data) {
            // console.log(data);
            console.log(data);
            that.find('button[type="submit"]').prop('disabled', 'disabled');
            $('.js-error-msg').hide();
            $('.js-valid-msg').show();
            // $('.js-progress').removeClass('animated');
            that.css({
                'pointer-events': 'none',
                'filter': 'blur(1px)',
                'opacity': '0.2'
            });
        },
        error: function (error) {
            var data = JSON.parse(error.responseText);
            var errorArr = Object.keys(data).reduce(function(prev, current) {
              prev = prev.concat(data[current])
              return prev;
            }, [])
            console.log(errorArr);
            console.log(errorArr.join('\n'))
            $('#js-notif-error-all').html(errorArr.join('<br>'))
            that.find('button[type="submit"]').prop('disabled', false);
            that.find('.js-error-msg').fadeIn();
            // $('.js-progress').removeClass('animated');
        }
    });
}

$(function () {
    $('.js-notif').on('submit', function (event) {
        event.preventDefault();
        var that = $(this);
        console.log('submit');
        submitForm(that);
    });
});
